module.exports = __webpack_public_path__ + "8b53df624b77efd212feef39db988f7a.png";